import { AlertType } from '../../../alerts/models';
import { BetslipError } from '../../errors/betslip-error';
import { ErrorViewModel } from '../../models/models';
import {
    isBetslipStatusInsufficientMoney,
    isGroupPickError,
    isNoBetBuilderSystemPreCheck,
    isRewardTokensError,
    isUnderMinimumStakeErrorPreCheck,
    isUnderMinimumWinningsErrorPreCheck,
} from './betslip-errors-utils';

export function getErrorAlertType(error: BetslipError): AlertType {
    if (isBetslipStatusInsufficientMoney(error) || isUnderMinimumStakeErrorPreCheck(error) || isUnderMinimumWinningsErrorPreCheck(error)) {
        return AlertType.Error;
    }

    if (isNoBetBuilderSystemPreCheck(error) || isGroupPickError(error) || isRewardTokensError(error)) {
        return AlertType.Warning;
    }

    return AlertType.Information;
}

export function getErrorMessage(error: ErrorViewModel) {
    const message = error.message;

    if (!message) {
        return null;
    }

    if (typeof message === 'string') {
        return message;
    }

    return message.message;
}
